import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const Debug = Loadable(
  lazy(() =>
    import("./Debug").then(({ Debug }) => ({
      default: Debug,
    })),
  ),
);

const ComponentsGallery = Loadable(
  lazy(() =>
    import("../../components/gallery/ComponentsGallery").then(
      ({ ComponentsGallery }) => ({ default: ComponentsGallery }),
    ),
  ),
);

const LoadingsPlayground = Loadable(
  lazy(() =>
    import("../../components/loadings/LoadingsPlayground").then(
      ({ LoadingsPlayground }) => ({ default: LoadingsPlayground }),
    ),
  ),
);

export const DebugRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.GenAI.Debug,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.DEBUG]} allowFullAccess>
        <Debug />
      </AuthorizedRoute>
    ),
  },
  {
    // Dev-only component gallery index: /components
    path: "/components",
    exact: true,
    element: <ComponentsGallery />,
  },
  {
    // Dev-only visual playground for loading components: /components/loadings
    path: "/components/loadings",
    exact: true,
    element: <LoadingsPlayground />,
  },
];
